module.exports = __webpack_public_path__ + "static/media/icon-menu.e64c542d.svg";